module.exports = __webpack_public_path__ + "img/5.d4a24dc5.jpg";